









































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import $ from 'jquery';
import { Component, Prop, Vue, Mixins, Watch, Emit } from 'vue-property-decorator';
import SimpleMap from '../../../core/components/SimpleMap.vue';
import Combobox from '../../../core/components/Combobox.vue';
import SimpleTable from '../../../core/components/SimpleTable.vue';
import DatePickerRange from '../../../core/components/DatePickerRange.vue';
import TableArrows from '../../../core/components/TableArrows.vue';
import AlertBox from '../../../core/components/AlertBox.vue';
import Input from '../../../core/components/Input.vue';
import Button from '../../../core/components/Button.vue';
import ButtonShowCalibrationsZafra from '../ButtonShowCalibrationsZafra.vue';
import Summary from '../../../core/components/Summary.vue';
import ModalRanchAssignCropType from '../ModalRanchAssignCropType.vue';
import ModalGenerateGeofences from '../ModalGenerateGeofences.vue';
import ModalAssignPolicyFarming from './ModalAssignPolicyFarming.vue';
import ModalJoinRanchs from '../ModalJoinRanchs.vue';
import RanchLinkButton from '../RanchLinkButton.vue';
import ModalLinkRanchs from '../ModalLinkRanchs.vue';
import FarmingActions from './FarmingActions.vue';
import ButtonFarmingSaveVersion from '../ButtonFarmingSaveVersion.vue';
import ModalNewHarvest from '../ModalNewHarvest.vue';
import ModalReprocessVehiclesAndPeriods from '../ModalReprocessVehiclesAndPeriods.vue';
import ModalReprocessSowingInfo from '../ModalReprocessSowingInfo.vue';
import CalcStatus from '../CalcStatus.vue';
import ModalGetNamesFromGeojson from '../ModalGetNamesFromGeojson.vue';
import DeleteConfirmation from '../../../tracking/components/Geofences/DeleteConfirmation.vue';
import { NAME_ROUTES } from '../../../core/utils/name-routes';
import { areaClasificada, areaSinClasificar, areaTotal, areaTotalCosecha, areaTotalTrabajadaCosecha, avanceBruto, chacrasCerradas, chacrasProceso, chacrasTotal, humedadMediaPonderada, porcentajeAvanceTotal, rindeMedioPonderado, tooltipSaveFarmingVersion } from '../../indicators'
import {
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
} from '../../../core/mixins';
import { getUrlVehicleConfiguration, getUrlRanchDetail, getParsedBounds, alertHarvesRecalculation, getUrlRanchSowingDetail, getOverlapAlertText, ranchStates, getRanchStateDescription } from '../../utils';
import {
    splitStringByIndex,
    getCompanyItemById,
    addItemsToListIfAreNotAdded,
    removeItemsFromList,
    getIdsFromList,
    matchedIndexIdInArray,
    sortObjectByPropertyName,
    getDateFromTimestamp,
    EventBus,
    TypeEventBus,
    getUniqueId,
    downloadFile,
    nullFormatter,
    goToUrl,
    geoJsonToTableFormat,
    parseFloatNumber,
    getAlertColorByPriority,
    booleanFormatter,
    getIndexFromList,
    PRIVILEGE_KEYS,
    formatCommaSeparatedStringList,
    isNullOrEmpty,
    ColorsList,
    ID,
    formatDate
} from '../../../core/utils';
import { itemsPerPageOptionsTable, tableSort } from '../../../core/utils/table-utils';
import { InsuranceServices } from '../../api/InsuranceServices';
import moment from 'moment';
import vColumnsResizable from '../../../../plugins/vue-columns-resizable'
import { ZafraNote } from '../../models';
import { farmingTypeOptions } from '../../helpers';
import { getValueAndUnit, getValueParsedByType, unitsValuesChoices, unitValues } from '../../../core/api';

@Component({
    directives:{
        'v-columns-resizable': vColumnsResizable
    },
    components: {
        ButtonFarmingSaveVersion,
        Input,
        Combobox,
        Button,
        DatePickerRange,
        SimpleTable,
        TableArrows,
        AlertBox,
        SimpleMap,
        DeleteConfirmation,
        ModalJoinRanchs,
        ModalRanchAssignCropType,
        ModalLinkRanchs,
        ModalNewHarvest,
        ModalGetNamesFromGeojson,
        CalcStatus,
        ModalReprocessVehiclesAndPeriods,
        ModalReprocessSowingInfo,
        Summary,
        RanchLinkButton,
        ButtonShowCalibrationsZafra,
        ModalGenerateGeofences,
        ModalAssignPolicyFarming,
        FarmingActions
    }
})
export default class DetailHarvestSowing extends Mixins(NotificationStoreHelper, CompanyStoreHelper, RootStoreHelper) {
    @Prop({ default: '' }) type: string;
    @Prop({ default: {} }) patchData: object;
    @Prop({
        default() {
            return [];
        }
    })
    ranchStates: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    cropTypeOptions: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    editing: boolean;
    showFarmingMap: boolean = false;
    visibleFarmingActions: boolean = false;
    @Prop({ default: '' }) zafraName: boolean;
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;
    summaryData: Array<object> = [];
    calculationStatus: null | object = null;
    classificationStatus: null | object = null;
    searchRanchs: string = '';
    noOptionsFound: string = 'No hay opciones que coincidan con la búsqueda';
    dateRangeSelected: any = [];
    searchavailableVehicles: string = '';
    availableVehicles: Array<object> = [];
    availableVehiclesSelected: Array<object> = [];
    selectedVehicles: Array<object> = [];
    allVehicles: Array<object> = [];
    selectedRanchs: Array<object> = [];
    availableSelectedVehicles: Array<object> = [];
    itemsDetail: Array<object> = [];
    action: string = '';
    generatingSatelliteImages: boolean = false;
    alreadyAskedHarvestedPolygons: boolean = false;
    gettingHarvestedPolygons: boolean = false;
    recalculating: boolean = false;
    classifiedArea: number = 0;
    unclassifiedArea: number = 0;
    loadingRanchs: boolean = false;
    visibleModalNewHarvest: boolean = false;
    loadingAvailableVehicles: boolean = false;
    seeLinkedRanchs: boolean = false;
    visibleModalReprocessVehiclesAndPeriods: boolean = false;
    visibleModalReprocessSowingInfo: boolean = false;
    reprocessPeriods: boolean = false;
    pendingGeofences: boolean = false;
    isActive: boolean = false;
    loadingBtnRawPolygons: boolean = false;
    loadingBtnUnRawPolygons: boolean = false;
    pendingDownloadProgress: boolean = false;
    collapsibleTopPanel: null | number = null;
    showPolicyModal: boolean = false;
    typePolygonViewing: string = 'unraw';
    savingNote: boolean = false;
    editedIndex: number = -1;
    defaultItem: object = {};
     filtersCropType: any = null;
    noteInfo: ZafraNote  = {
        public: false,
        text: ''
    };
    noteId: number = -1;
    editedItem: object = {
        id: 0,
        name: '',
        area: '',
        start_date: '',
        end_date: '',
        policy: '',
        harvest_type: ''
    };
    //delete modal
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    sowingReprocessData: object = {};
    harvestReprocessData: object = {};
    deleteBody: string = '';
    visibleModalJoinRanchs: boolean = false;
    visibleModalLinkRanchs: boolean = false;
    loadingMap: boolean = false;
    comboCropTypeValue: any | null = null;
    comboCropTypeResetValue: any | null = null;
    policyValue: any | null = null;
    policyResetValue: any | null = null;
    debounce: any | null = null;
    companySelected: any | null = null;
    ranchName: string = '';
    description: string = '';
    policyRanch: string = '';
    recalculatingSowing: boolean = false;
    forcingCalculate: boolean = false;
    companySelectedRV: boolean = false;
    recalculatingHarvest: boolean = false;
    seeProgressPolygon: boolean = false;
    selectedFeatures: any = [];
    companiesList: any = [];
    ranchsToDownload: any = [];
    policiesList: any = [];
    policyToSelect: object | null = null;
    selectedRanchToLink: object | null = null;
    currentRanchSowingLink: object | null = null;
    ranchToDelete: any = null;
    visibleModalGetNamesFromGeoJson: boolean = false;
    farmingDataWasLoaded: boolean = false;
    selectedRanchToFocus: any = null;
    headersRanchs: Array<object> = [];
    headersRanchsHarvest:Array<object> = [
        {
            text: 'Poliza',
            value: 'properties.policy.number',
            sortable: true,
        },
        {
            text: 'Chacra',
            value: 'properties.name',
            align: 'left',
            sortable: true
        },
        {
            text: 'Alertas',
            value: 'properties.warnings',
            sortable: true
        },
        {
            text: 'Area',
            value: 'properties.area',
            unit: unitValues[unitsValuesChoices.area],
            align: 'center',
            sortable: true,
        },
        {
            text: 'Tipo de cultivo',
            value: 'properties.harvest_type',
            filter: this.filterByCropType,
            align: 'center',
            sortable: true,
        },
        {
            text: '% Avance',
            value: 'properties.progress_percent',
            align: 'center',
            sortable: true
        },
        {
            text: 'Rendimiento',
            value: 'properties.performance',
            unit: unitValues[unitsValuesChoices.performance],
            align: 'left',
            sortable: true
        },
        {
            text: 'Link Siembra',
            value: 'properties.sowing_ranch_link',
            class: 'hide-header',
            align: ' d-none',
            filter: this.filterByRanchLink,
            sortable: true
        },
        {
            text: 'Humedad',
            value: 'properties.humidity',
            unit: unitValues[unitsValuesChoices.humidity],
            align: 'center',
            sortable: true
        },
        {
            text: 'Inicio',
            value: 'properties.start_date',
            align: 'left',
            sortable: true
        },
        {
            text: 'Fin',
            value: 'properties.end_date',
            align: 'left',
            sortable: true
        },
        {
            text: 'Calibr.',
            value: 'properties.custom_calibrations',
            align: 'center',
            sortable: true,
        },
        {
            text: 'Vehículos',
            value: 'properties.vehicles',
            align: 'left',
            sortable: true
        },
        {
            text: 'Estado',
            value: 'properties.state',
            align: 'left',
            sortable: true,
        },
        {
            text: 'Acciones',
            value: 'actions',
            sortable: true,
            width: '140px'
        }
    ];
    headersRanchsSowing: Array<object> = [
                {
                    text: 'Chacra',
                    value: 'name',
                    sortable: true,
                },
                {
                    text: 'Alertas',
                    value: 'warnings',
                    sortable: true
                },
                {
                    text: 'Area',
                    value: 'area',
                    unit: unitValues[unitsValuesChoices.area],
                    sortable: true
                },
                {
                    text: 'Area Siembra',
                    value: 'sown_area',
                    unit: unitValues[unitsValuesChoices.area],
                    sortable: true
                },
                {
                    text: 'Area Resiembra',
                    value: 'resowing_sown_area',
                    unit: unitValues[unitsValuesChoices.area],
                    sortable: true
                },
                {
                    text: 'Tipo de cultivo',
                    value: 'harvest_type',
                    align: 'center',
                    filter: this.filterByCropType,
                    sortable: true
                },
                {
                    text: 'Inicio',
                    value: 'start_date',
                    align: 'center',
                    sortable: true
                },
                {
                    text: 'Fin',
                    value: 'end_date',
                    align: 'center',
                    sortable: true
                },
                {
                    text: 'Vehículos',
                    value: 'vehicles',
                    align: 'center',
                    sortable: true
                },
                {
                    text: 'Link Cosecha',
                    value: 'harvest_ranch_link',
                    class: 'hide-header',
                    align: ' d-none',
                    filter: this.filterByRanchLink,
                    sortable: true
                },
                {
                    text: 'Acciones',
                    value: 'actions',
                    sortable: true,
                    width: '120px'
                }
            ];
    headersSowing: any = [
        {
            text: 'Sembradoras',
            value: 'description',
            sortable: true
        },
        {
            text: 'Empresa',
            value: 'company.name',
            filter: this.filterByCompany
        },
        {
            text: 'VIN',
            value: 'vin',
            width: '100px',
            sortable: true
        }
    ];
    headersHarvest: any = [
        {
            text: 'Cosechadoras',
            value: 'description',
            sortable: true
        },
        {
            text: 'Empresa',
            value: 'company.name',
            filter: this.filterByCompany
        },
        {
            text: 'VIN',
            value: 'vin',
            width: '100px',
            sortable: true
        }
    ];
    poligonsResponse: any = null;
    harvestedPolygons: any = null;
    cropTypeRv: boolean = false;
    visibleModalAssignCropType: boolean = false;
    visibleModalGenerateGeofences: boolean = false;

    generatingGeofences(value){
        this.pendingGeofences = value;
    }

    visibilityModalAssignCropType(value: boolean){
        this.visibleModalAssignCropType = value;
    }

    visibilityModalGenerateGeofences(value: boolean){
        this.visibleModalGenerateGeofences = value;
    }

    clickBtnAssignCropType(){
        //aca
        this.visibilityModalAssignCropType(true);
    }

    clickBtnGenerateGeofences(){
        this.visibilityModalGenerateGeofences(true);
    }

    updateCropTypeSelected(value) {
        this.filtersCropType = value;
    }
    updateCropTypeSelectedRv(value) {
        this.cropTypeRv = value;
    }

    get wasAlreadySaved(){
        return this.patchData[this.type]['has_saved_version']
    }

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    filterByRanchLink(ranchLink) {
        return !this.seeLinkedRanchs ? true : ranchLink !== null
    }

    filterByCropType(cropType) {
        if(this.filtersCropType == null){ 
            return true
        }
        return cropType == this.filtersCropType['value']

    }


    addNewLinkToRanch(newRanchLink, harvestRanchId){
        //compruebo si el nuevo link existe en otra chacra
        //si existe en otra chacra quito el link de esa chacra
        //antes de asignar el nuevo
        let newLinkId = newRanchLink['id'];
        let indexPreviousLink = -1;
        if(this.isSowing){
           indexPreviousLink = this.itemsDetail.findIndex(
            item => item['harvest_ranch_link'] !== null &&
            item['harvest_ranch_link']['id'] == newLinkId
        )
        }else{
            indexPreviousLink = this.itemsDetail.findIndex(
                item => item['properties']['sowing_ranch_link'] !== null &&
                item['properties']['sowing_ranch_link']['id'] === newLinkId
            )
        }
        if(indexPreviousLink !== -1){
            if(this.isSowing){
                this.itemsDetail[indexPreviousLink]['harvest_ranch_link'] = null;
            }else{
                this.itemsDetail[indexPreviousLink]['sowing_ranch_link'] = null;
            }
        }
        this.updateRanchLinkByRanchId(harvestRanchId, newRanchLink) 
    }


    updateRanchLinkByRanchId(ranchId: number, newLink:object | null){
        this.pendingRanchs(true);
        let oldItems = this.itemsDetail;
        this.itemsDetail = [];
        let indexInItemsList = -1;
        if(this.isSowing){
            indexInItemsList = oldItems.findIndex(
                item => item['id'] === ranchId
            )
            if(indexInItemsList !== -1){
                this.$set(oldItems[indexInItemsList], 'harvest_ranch_link', newLink);
            }
        }else{
            indexInItemsList = oldItems.findIndex(
                item => item['properties']['ranch_id'] === ranchId
            )
            if(indexInItemsList !== -1){
                this.$set(oldItems[indexInItemsList]['properties'], 'sowing_ranch_link', newLink);
            }
        }

        setTimeout(() => {
               this.pendingRanchs(false); 
               this.itemsDetail = oldItems;
        }, 500);

    }

    get canAddRanchsTooltip(){
        let defaultValue = 'Alta Chacra';
        if(!this.canAddRanchs){
            defaultValue = 'No existe la '
            if(this.isSowing){
                defaultValue += 'Siembra'
            }else{
                defaultValue += 'Cosecha'
            }
        }
        return defaultValue
    }

    removeLinkFromRanch(ranchIdToRemoveLink){
        this.updateRanchLinkByRanchId(ranchIdToRemoveLink, null) 
    }

    collapseSettings(){
        if(this.collapsibleTopPanel == 0){
            let oldRangeDate = this.dateRangeSelected;
            this.dateRangeSelected = [];

            this.dateRangeSelected = oldRangeDate;
        }
    }

    onNewAddedGeojson(polyName, newCoords, polyType){
        let newPolygon = {
            name: polyName,
            coords: newCoords,
            type: polyType
        }
        InsuranceServices.addNewPolygonToSowing(this.getSowingId, newPolygon)
            .then(res => {
                this.$_successLoadingDialog({
                    response: res,
                    alternative_msg: 'Se agregaron las chacras'
                });
                this.reloadFarmingDetail();
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudieron agregar las chacras');
            });
    }

    created() {
        this.action = this.type === 'harvest' ? 'Cosecha' : 'Siembra';
    }

    clickReprocessPeriods(){
        this.reprocessPeriods = true;
        this.visibilityModalReprocess(true);
    }

    clickReprocessVehicles(){
        this.reprocessPeriods = false;
        this.visibilityModalReprocess(true);
    }

    clickShowReprocessData(){
        this.visibilityModalReprocessSowingInfo(true);
    }

    visibilityModalReprocess(value){
        this.visibleModalReprocessVehiclesAndPeriods = value;
    }
    visibilityModalReprocessSowingInfo(value){
        this.visibleModalReprocessSowingInfo = value;
    }

    customSort(items: any[], sortBy: string[], sortDesc: boolean[]) {
        return tableSort(items, sortBy, sortDesc);
    }

    getAreaParsed(area){
       return parseFloatNumber(area, 1)
    }

    mounted() {
        this.loadPatchData();
        this.$nextTick(() => {
            this.getPolygons();
            this.getEnabledVehicles();
            this.setRanchHeaders();
        });      
    }

    updateRowTooltips() {
        setTimeout(() => {
            $('.truncate-row')
                .find('td')
                .addClass('truncate-text');
            $('.truncate-text').each(function() {
                
                    let text = $(this).text();
                    text = text.split('\\s\\s+');
                    $(this).attr('title', text);

                    if ($(this).attr('title') === 'check_box_outline_blank'){
                        $(this).removeAttr('title')
                    }
                
            });
        }, 0);
    }

    updateSearchRanchs(value) {
        this.searchRanchs = value;
    }

    pendingRanchs(value) {
        this.loadingRanchs = value;
    }

    updateSowingReprocessData(data){
        this.sowingReprocessData = data;
    }

    updateHarvestReprocessData(data){
        this.sowingReprocessData = data;
    }

    setRecalculatingValue() {
        if (this.isSowing) {
            this.recalculating = this.patchData[this.type]['recalculating'];
            this.classifiedArea = this.patchData[this.type]['classified_area']
            this.unclassifiedArea = this.patchData[this.type]['unclassified_area'];
            this.classificationStatus = this.patchData[this.type]['classification_status'];
            if(this.patchData && this.patchData[this.type] && this.patchData[this.type]['sowing_reprocess_data']){
                this.updateSowingReprocessData(this.patchData[this.type]['sowing_reprocess_data'])
            }
            if(this.patchData && this.patchData[this.type] && this.patchData[this.type]['harvest_reprocess_data']){
                this.updateHarvestReprocessData(this.patchData[this.type]['harvest_reprocess_data'])
            }
            this.calculationStatus = this.patchData[this.type]['calculation_status'];
        } else {
            this.recalculating = this.patchData[this.type]['has_changes'];
            this.calculationStatus = this.patchData[this.type]['calculation_status'];
        }
    }

    updateSummaryHarvest(items: Array<object>){
        let area_total = 0,
            area_total_trabajada = 0,
            chacras_total = 0,
            chacras_cerradas = 0,
            chacras_proceso = 0,
            avance_total = 0,
            rinde_medio_ponderado = 0,
            sum_perf = 0,
            sum_hum = 0,
            sum_area_progress_performance = 0,
            sum_area_progress_humidity = 0,
            humedad_media_ponderada = 0;
        let ranchState = ranchStates;

        for (let a = 0; a < items.length; a++) {
            const item = items[a]['properties'];
            let area = item['area'];
            let performance = item['performance'];
            let humidity = item['humidity'];
            let progress = item['progress_percent'];
            let state = item['state'];
            let current_area = (progress / 100) * area;

            area_total += area;
            area_total_trabajada += current_area;

            if (current_area > 0) {
                if (performance > 0) {
                    sum_perf += performance * current_area * progress;
                    sum_area_progress_performance += current_area * progress;
                }
                if (humidity > 0) {
                    sum_hum += humidity * current_area * progress;
                    sum_area_progress_humidity += current_area * progress;
                }
            }

            if (state == ranchState[1] || state === ranchState[2]) {
                chacras_proceso++;
            }
            if (state === ranchState[0]) {
                chacras_cerradas++;
            }
        }

        chacras_total = items.length;

        avance_total = (area_total_trabajada / area_total) * 100 || 0;
        rinde_medio_ponderado = sum_perf / sum_area_progress_performance || 0;
        humedad_media_ponderada = sum_hum / sum_area_progress_humidity || 0;

        this.summaryData = [
             {
                text: areaTotalCosecha.text,
                value: getValueAndUnit(area_total, unitsValuesChoices.area),
                info: areaTotalCosecha.tooltip
            },
            {
                text: areaTotalTrabajadaCosecha.text,
                value: getValueAndUnit(area_total_trabajada, unitsValuesChoices.area),
                info: areaTotalTrabajadaCosecha.tooltip
            },
            {
                text: chacrasTotal.text,
                value: chacras_total,
                info: chacrasTotal.tooltip
            },
            {
                text: chacrasCerradas.text,
                value: chacras_cerradas,
                info: chacrasCerradas.tooltip
            },
            {
                text: porcentajeAvanceTotal.text,
                value: getValueAndUnit(avance_total, unitsValuesChoices.humidity),
                info: porcentajeAvanceTotal.tooltip
            },
            {
                text: chacrasProceso.text,
                value: chacras_proceso,
                info: chacrasProceso.tooltip
            },
            {
                text: rindeMedioPonderado.text,
                value:getValueAndUnit(rinde_medio_ponderado, unitsValuesChoices.performance),
                info: rindeMedioPonderado.tooltip
            },
            {
                text: humedadMediaPonderada.text,
                value: getValueAndUnit(humedad_media_ponderada, unitsValuesChoices.humidity),
                info: humedadMediaPonderada.tooltip
            }
        ];
    }

    updateSummarySowing(items: Array<object>) {
        let area_total = this.classifiedArea + this.unclassifiedArea,
            area_clasificada = this.classifiedArea,
            area_sin_clasificar = this.unclassifiedArea,
            avance_bruto = 0;
        
        for (let a = 0; a < items.length; a++) {
            const item = items[a];
            let sown_area = item['sown_area'];
            avance_bruto += sown_area;
        }
        avance_bruto = avance_bruto + this.unclassifiedArea
        this.setSummaryData(
            area_total,
            area_clasificada,
            area_sin_clasificar,
            avance_bruto
        )
    }

    setSummaryData(
        area_total,
        area_clasificada,
        area_sin_clasificar,
        avance_bruto
    ) {
        this.summaryData = [
            {
                text: areaTotal.text,
                value: getValueAndUnit(area_total, unitsValuesChoices.area),
                info: areaTotal.tooltip
            },
            {
                text: areaClasificada.text,
                value: getValueAndUnit(area_clasificada, unitsValuesChoices.area),
                info: areaClasificada.tooltip
            },
            {
                text: areaSinClasificar.text,
                value: getValueAndUnit(area_sin_clasificar, unitsValuesChoices.area),
                info: areaSinClasificar.tooltip
            },
            {
                text: avanceBruto.text,
                value: getValueAndUnit(avance_bruto, unitsValuesChoices.area),
                info: avanceBruto.tooltip
            },
        ];
    }


    loadPatchData() {
        this.pendingRanchs(true);
        // console.log("Detalle siembra", this.patchData);
        let sowingOrHarvestData = this.patchData[this.type];
        if (sowingOrHarvestData !== null) {
            this.itemsDetail = [];
            this.dateRangeSelected = [sowingOrHarvestData['start_date'], sowingOrHarvestData['end_date']];
            this.setRecalculatingValue();
            this.description = sowingOrHarvestData['name'];
            this.isActive = sowingOrHarvestData['active'];
            this.companiesList = this.$_getCompanies.sort(sortObjectByPropertyName('name'));
            this.selectedVehicles = sowingOrHarvestData['vehicles'];
            this.allVehicles = sowingOrHarvestData['vehicles'];
            this.loadNoteInfo(sowingOrHarvestData)
            this.setRanchsList();
            this.pendingRanchs(false);
            this.farmingDataWasLoaded = true;
        } else {
            this.updateDescriptionValue(this.zafraName);
        }
    }

    loadNoteInfo(sowingOrHarvestData){
        let noteInfo = sowingOrHarvestData['note'];
        if(noteInfo !== null){
            this.noteInfo = {
                public: noteInfo['public'],
                text: noteInfo['text'],
            }
            this.noteId = noteInfo['id'];
        }
    }

    getColorProgressBtn() {
        return getAlertColorByPriority(1);
    }

    updateSelectedCompany(value) {
        this.companySelected = value;
    }
    updateCompanySelectedRV(value) {
        this.companySelectedRV = value;
    }

    setRanchsList() {
        if (this.isSowing) {
            this.setRanchsSowing();
        }
    }

    toggleRanchVisibility(item) {
        let itemIsVisible = !item['isVisible'];
        delete item['isVisible'];

        this.$set(item, 'isVisible', itemIsVisible);

        // console.log("toggle ranch visibility", item['isVisible']);

        let featureToToggle: google.maps.Data.Feature;

        if (this.isSowing) {
            featureToToggle = this.mapDetailHarvestSowing.getFeatureById(item['customId']);
        } else {
            featureToToggle = this.mapDetailHarvestSowing.getFeatureById(item['properties']['customId']);
        }
        this.mapDetailHarvestSowing.updateFeatureVisibility(featureToToggle, itemIsVisible);
    }

    get getFilteredRanchs() {
        let filteredRanchs = this.itemsDetail;
        let ranchsIds: ID[] = []

        if(this.selectedRanchs.length !== 0){
            filteredRanchs = this.selectedRanchs;
        }

        if(this.isSowing){
            ranchsIds = getIdsFromList(filteredRanchs)
        }else{
            ranchsIds = filteredRanchs.map(item => item['properties']['ranch_id'])
        }
        
        return ranchsIds
    }

    downloadProgress() {
        this.pendingDownloadProgress = true;
        let fileName = this.getFileName();
        let ids = this.getFilteredRanchs;
        InsuranceServices.getRanchListGeojson(ids, {})
            .then(res => {
                let fileData = JSON.stringify(res['data']);
                downloadFile(fileName, fileData);
                this.pendingDownloadProgress = false;
            })
            .catch(() => {
                this.pendingDownloadProgress = false;
            });
    }

    toggleHarvestedPolygonsOnMap(visible:boolean){
        if(!this.existHarvestedPolygons){
            this.$_showEmptyLastReport('No hay polígonos de avance para mostrar');
            return;
        }

        if (visible) {
            this.mapDetailHarvestSowing.addExtraGeojsonLayer(this.harvestedPolygons);
        }else{
            this.mapDetailHarvestSowing.removeExtraGeojsonLayer(this.harvestedPolygons);
        }
    }

    async toggleHarvestedPolygons(){
        if(this.itemsDetail.length === 0){
            this.$_showEmptyLastReport('No hay chacras para ver los polígonos de avance');
            return;
        }
        
        if(this.existHarvestedPolygons){
            //si hay poligonos de avance hago el toggle
            this.toggleProgressPolygon();
        }else{
            //me fijo si ya pregunte por los poligonos de avance
            if(this.alreadyAskedHarvestedPolygons){
                //si ya pregunte y no hay poligonos de avance muestro mensaje
               this.$_showEmptyLastReport('No hay polígonos de avance para mostrar');
            }else{
                //si no pregunte por los poligonos de avance los pido
                this.gettingHarvestedPolygons = true;
                InsuranceServices.getHarvestedPolygons(
                    this.getHarvestId
                ).then(res => {
                    let harvestedPolygons = res['harvested_polygons'];
                    this.gettingHarvestedPolygons = false;
                    this.alreadyAskedHarvestedPolygons = true;
                    if(harvestedPolygons.features.length > 0){
                        this.saveHarvestedPolygon(harvestedPolygons);
                    }else{
                        this.$_showEmptyLastReport('No hay polígonos de avance para mostrar');
                    }
                }).catch(err => {
                    this.gettingHarvestedPolygons = false;
                    this.$_catchLoadingDialog({
                        response: err.response.data || {},
                        alternative_msg: 'No se pudieron obtener los polígonos de avance'
                    });
                });
            }
            
        }
    }


    toggleProgressPolygon() {
        let polygons: any = [];
        this.seeProgressPolygon = !this.seeProgressPolygon;
        this.toggleHarvestedPolygonsOnMap(this.seeProgressPolygon);
    }

    toggleProgressLayerToMap(geoJson, visible){
        if(visible){
            this.mapDetailHarvestSowing.addGeojsonLayer(geoJson);
        }
    }

    seeRanchTelemetry(item) {
        let img = item['properties']['images']['performance_telemetry_transparent'];
        let imgBounds = getParsedBounds(item['properties']['bounds']);
        item['see_performance'] = !item['see_performance'];
        if (item['see_performance']) {
            this.mapDetailHarvestSowing.setGroundOverlayInMap(img, imgBounds, true);
        } else {
            this.mapDetailHarvestSowing.hideGroundOverlayFromMap(img);
        }
    }

    setRanchsHarvest(geoJson) {
        let items = geoJson['features'].length == 0 ? {items: []} : geoJsonToTableFormat(geoJson);
        let harvestRanchs = items['items'];
        for (let a = 0; a < harvestRanchs.length; a++) {
            const ranch = harvestRanchs[a];
            ranch['selected'] = 'false';
            ranch['isVisible'] = true;
            let ranchCalibrations = ranch['properties']['calibrations'];
            let ranchHasCsv = ranch['properties']['has_csv'];

            ranch['properties']['custom_calibrations'] = {
                calibrations: ranchCalibrations,
                has_csv: ranchHasCsv
            }
            
            ranch['see_performance'] = false;

            if(ranch['properties']['state'] !== 0 && this.isCarrierLimited){
                ranch['properties']['performance'] = '-';
                ranch['properties']['humidity'] = '-';
            }
           
            let vehicleData: any = '-';
            ranch['properties']['state'] = getRanchStateDescription(
                ranch['properties']['state'],
                this.ranchStates
            )
            if (ranch && ranch['properties'] && ranch['properties']['policy']) {
                // console.log('policy_id', ranch['properties']);
                let newPolicy = {
                    id: ranch['properties']['policy']['id'],
                    number: ranch['properties']['policy']['number'],
                    secured_area: ranch['properties']['policy']['secured_area']
                };
                this.addNewPolicyToList(newPolicy);
            }


            if (ranch && ranch['properties'] && ranch['properties']['vehicles'].length > 0) {
                vehicleData = '';
                for (let index = 0; index < ranch['properties']['vehicles'].length; index++) {
                    const vehicleId = ranch['properties']['vehicles'][index];
                    let vehDescription = this.getVehicleData('description', vehicleId);
                    let vehVin = this.getVehicleData('vin', vehicleId);
                    let vehData = vehDescription + '(' + vehVin + ')';
                    if (index > 0) {
                        vehData += ', ';
                    }
                    vehicleData += vehData;
                }
            }
            ranch['properties']['vehicles'] = vehicleData;
        }
        this.updateSummaryHarvest(items['items'])
        this.itemsDetail = items['items'];
    }

    setRanchsSowing() {
        let self = this;
        let itemsSowing: Array<object> = [];
        if (this.patchData[this.type]['ranchs']) {
            pushRanch(this.patchData[this.type]['ranchs'], null);
        }

        function pushRanch(ranchs, policy?) {
            for (let b = 0; b < ranchs.length; b++) {
                let ranch = ranchs[b];
                ranch['map'] = true;
                ranch['harvest_type'] = ranch['harvest_type'] == null ? '-' : ranch['harvest_type'];
                ranch['finished'] = ranch['finished'] == null ? 'Inactiva' : 'Cosechando';
                ranch['customId'] = getUniqueId();

                let vehicleData: any = '-';

                if (ranch && ranch['vehicles'] && ranch['vehicles'].length > 0) {
                    vehicleData = '';
                    for (let index = 0; index < ranch['vehicles'].length; index++) {
                        const vehicleId = ranch['vehicles'][index];
                        let vehDescription = self.getVehicleData('description', vehicleId);
                        let vehVin = self.getVehicleData('vin', vehicleId);
                        let vehData = vehDescription + '(' + vehVin + ')';
                        if (index > 0) {
                            vehData += ', ';
                        }
                        vehicleData += vehData;
                    }
                }
                
                ranch['vehicles'] = vehicleData;
                ranch['resowing_sown_area'] = ranch['resowing'] !== null ? ranch['resowing']['sown_area'] : null;
                ranch['selected'] = 'false';
                ranch['isVisible'] = true;

                if (policy) {
                    ranch['policy'] = policy;
                }
                itemsSowing.push(ranch);
            }
        }
        this.updateSummarySowing(itemsSowing)
        this.itemsDetail = itemsSowing;
        // this.itemsDetail = this.harcodeRanchs;
    }

    selectedRanchFromTable(itemSelected) {
        //seleccionar o des-seleccionar chacras desde la tabla
        this.updateSelectedRanchList(itemSelected);
    }

    updateAvailableVehicles(vehicles) {
        this.availableVehicles = vehicles;
    }

    updatesearchAvailableVehicles(value) {
        this.searchavailableVehicles = value;
    }

    updateRangeDate(value) {
        this.dateRangeSelected = [];
        this.dateRangeSelected = value;
    }

    updateavailableVehiclesSelected(rows) {
        this.availableVehiclesSelected = rows;
    }

    updateSelectedVehicles(rows) {
        this.availableSelectedVehicles = rows;
    }

    setLoadingMap(value) {
        this.loadingMap = value;
    }

    get getPoliciesOptions() {
        return this.policiesList.map(function(item) {
            return {
                id: item['id'],
                number: item['number'],
                secured_area: item['secured_area']
            };
        });
    }

    get isSowing() {
        return this.type === 'sowing' ? true : false;
    }

    get getAlertText() {
        if (this.isSowing) {
            return 'Siembra marcada para recalcular desde el inicio';
        } else {
            return alertHarvesRecalculation;
        }
    }

    get getAlertColor() {
        return getAlertColorByPriority();
    }

    get existSowingDetail() {
        return this.patchData && this.patchData['sowing'] !== null ? true : false;
    }

    get canAddRanchs(){
        if(this.patchData && this.patchData[this.type] !== null){
            return true
        }
        return false
    }


    get existHarvestDetail() {
        return this.patchData && this.patchData['harvest'] !== null ? true : false;
    }

    get existHarvestedPolygons() {
        return this.harvestedPolygons !== null
    }

    get fetchedHarvestedPolygons(){
        return this.alreadyAskedHarvestedPolygons ? true : false;
    }


    get getRecalculationNote() {
        return (
            '<b>NOTA:</b> Todas las modificaciones realizadas en esta seccion generarán un re-calculo de la <b>' +
            this.action +
            '</b> la cual se ejecutará automaticamente en el proximo reprocesado (a las 12hs UTC-3)'
        );
    }

    get isRecalculating() {
        return this.recalculating ? true : false;
    }

    get getselectedVehiclesName() {
        return this.isSowing ? 'Sembradoras seleccionadas' : 'Cosechadoras seleccionadas';
    }

    get getavailableVehiclesTitle() {
        return this.isSowing ? 'Sembradoras disponibles' : 'Cosechadoras disponibles';
    }

    get visibilityUnirChacras() {
        if (this.selectedRanchs.length < 2) {
            return false;
        } else {
            return true;
        }
    }

    get getSelectedRanchs() {
        return getIdsFromList(this.selectedRanchs);
    }

    get visibilityRecalculatingBtn() {
        if (this.isRecalculating) {
            return false;
        } else {
            if (this.isSowing && !this.existSowingDetail) {
                return false;
            }
            if (!this.isSowing && !this.existHarvestDetail) {
                return false;
            }
        }
        return true;
    }

    get existsSelectedVehicles() {
        return this.selectedVehicles.length > 0 ? true : false;
    }

    get headersSelectedVehicles() {
        if (this.isSowing) {
            return [
                {
                    text: 'Sembradoras',
                    value: 'description',
                    sortable: true
                },
                {
                    text: 'VIN',
                    value: 'vin',
                    width: '100px',
                    sortable: true
                },
                {
                    text: 'Empresa',
                    value: 'company.name',
                    sortable: true
                },
                {
                    text: 'Acciones',
                    value: 'actions',
                    align: 'center',
                    sortable: true,
                    width: '120px'
                }
            ];
        } else {
            return [
                {
                    text: 'Cosechadoras',
                    value: 'description',
                    sortable: true
                },
                {
                    text: 'VIN',
                    value: 'vin',
                    width: '100px',
                    sortable: true
                },
                {
                    text: 'Empresa',
                    value: 'company.name',
                    sortable: true
                },
                {
                    text: 'Acciones',
                    value: 'actions',
                    align: 'center',
                    sortable: true,
                    width: '120px'
                }
            ];
        }
    }

    get headersAvailableVehicles() {
        if (this.isSowing) {
            return this.headersSowing;
        } else {
            return this.headersHarvest;
        }
    }

    setRanchHeaders() {
        if (this.isSowing) {
            this.headersRanchs = this.headersRanchsSowing; 
        } else {
            this.headersRanchs = this.headersRanchsHarvest;
        }
    }

    processingNote(value: boolean){
        this.savingNote = value;
    }


    saveNote(){
        let sowingOrHarvestData = this.patchData[this.type]; //harvest or sowing object
        if(sowingOrHarvestData == null){
            let msg = `No existe la ${this.isSowing ? 'Siembra' : 'Cosecha'}`;
            this.noteInfo = {
                public: false,
                text: ''
            }
            this.$_showEmptyHistoricalData(msg);
            return
        }
        
        let noteIsEmpty = isNullOrEmpty(this.noteInfo.text);
        if(noteIsEmpty){
            this.noteInfo.public = false;
        } 
        
        let sowingOrHarvestId = sowingOrHarvestData['id'];
        let needToCreateNote = this.noteId == -1 ? true : false;

        let config:ZafraNote = {
            text: this.noteInfo.text,
            public: this.noteInfo.public
        }

        if (this.isSowing) {
            if(needToCreateNote){
                this.createNoteForSowingFarming(sowingOrHarvestId, config)
            }else{
                this.patchNoteForSowingFarming(this.noteId, config)
            }
        }else{
            if(needToCreateNote){
                this.createNoteForHarvestFarming(sowingOrHarvestId, config);
            }else{
                this.patchNoteForHarvestFarming(this.noteId, config);
            }
        }
        
    }

    patchNoteForSowingFarming(noteId: number, config: ZafraNote){
        this.processingNote(true);
        InsuranceServices.patchNoteToSowingFarming(
            noteId,
            config
        ).then((res) => {
            this.processingNote(false);
            this.updateNoteId(res['data']['id']);
            this.$_showAddPointOfInterest('Nota modificada con exito')
        }).catch((e) => {
            this.$_catchLoadingDialog({
                response: e.response.data || {},
                alternative_msg: 'No se pudo modificar la nota'
            })
            this.processingNote(false);
        })
    }
    createNoteForSowingFarming(sowingOrHarvestId: number, config: ZafraNote){
        this.processingNote(true);
        InsuranceServices.addNoteToSowingFarming(
            sowingOrHarvestId,
            config
        ).then((res) => {
            this.updateNoteId(res['id']);
            this.processingNote(false);
            this.$_showAddPointOfInterest('Nota creada con exito')
        }).catch((e) => {
            this.processingNote(false);
            this.$_catchLoadingDialog({
                response: e.response.data || {},
                alternative_msg: 'No se pudo crear la nota'
            })
        })
    }

    updateNoteId(noteId: number){
        this.noteId = noteId
    }
    
    patchNoteForHarvestFarming(noteId: number, config: ZafraNote){
        this.processingNote(true);
        InsuranceServices.patchNoteToHarvestFarming(
            noteId,
            config
        ).then((res) => {
            this.processingNote(false);
            this.updateNoteId(res['data']['id']);
            this.$_showAddPointOfInterest('Nota modificada con exito')
        }).catch((e) => {
            this.$_catchLoadingDialog({
                response: e.response.data || {},
                alternative_msg: 'No se pudo modificar la nota'
            })
            this.processingNote(false);
        })
    }
    createNoteForHarvestFarming(sowingOrHarvestId: number, config: ZafraNote){
        this.processingNote(true);
        InsuranceServices.addNoteToHarvestFarming(
            sowingOrHarvestId,
            config
        ).then((res) => {
            this.processingNote(false);
            this.updateNoteId(res['id']);
            this.$_showAddPointOfInterest('Nota creada con exito')
        }).catch((e) => {
            this.processingNote(false);
            this.$_catchLoadingDialog({
                response: e.response.data || {},
                alternative_msg: 'No se pudo crear la nota'
            })
        })
    }


    editRanch(item) {
        this.selectedRanchToFocus = null;
        this.updateComboCropTypeValue(null);
        if (this.isSowing) {
            if (item['harvest_type'] !== '-') {
                this.updateComboCropTypeValue(
                    this.getCropTypeRanchSelected({ harvest_type: item['harvest_type'] }, true)
                );
            }
        } else {
            this.headersRanchsHarvest[0]['width'] = '200px'
            console.log('item[properties][policy]', item['properties']['policy']);
            if(item['properties']['policy']['id']){
                this.updatePolicyValue(item['properties']['policy']);
            }
            if (item['properties']['harvest_type'] !== '-') {
                this.updateComboCropTypeValue(this.getCropTypeHarvestRanchSelected(item, true));
            }
            item['properties']['id'] = item['properties']['ranch_id'];
        }

        this.selectedRanchToFocus = {
            item: item,
            value: true
        };
        this.selectedRanchs = [];
        if(this.isSowing){
            this.editPolygon(item['customId']);
        }else{
            this.editPolygon(item['properties']['customId']);
        }
        this.tableRanchClicked(this.selectedRanchToFocus);
        this.ranchName = this.isSowing ? item['name'] : item['properties']['name'];
        this.editedIndex = this.itemsDetail.indexOf(item);
        this.editedItem = Object.assign({}, item);
    }

    editPolygon(featureCustomId: string){
        this.mapDetailHarvestSowing.editFeatureById(featureCustomId);
    }

    deleteItem(item) {
        const index = this.itemsDetail.indexOf(item);
        if (index !== -1) {
            this.itemsDetail.splice(index, 1);
        }
    }

    close() {
        let self = this;
        setTimeout(() => {
            if(this.selectedRanchToFocus){
                this.selectedRanchToFocus['value'] = false;
                this.tableRanchClicked(this.selectedRanchToFocus);
            }
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
            this.cancelEditPolygonAction();
        }, 300);
        this.updateComboCropTypeValue(null);
        delete this.headersRanchsHarvest[0]['width']
    }

    updateSowingRanch(ranchName: string, cropTypeSelected: object | null, oldFeature: google.maps.Data.Feature){
        let customId = oldFeature.getProperty('customId') as string;
        let indexInItemsList = getIndexFromList(this.itemsDetail, 'customId',customId );
        this.editedItem['id'] = this.itemsDetail[indexInItemsList]['id'];
        this.editedItem['harvest_type'] = cropTypeSelected !== null ? cropTypeSelected['value'] : null;
        this.editedItem['name'] = ranchName;
        this.patchSowingRanch(this.editedItem);
    }
    updateHarvestRanch(ranchName: string, cropTypeSelected: object | null, oldFeature: google.maps.Data.Feature){
        let customId = oldFeature.getProperty('customId');
        let indexInItemsList = this.itemsDetail.findIndex(item => item['properties']['customId'] === customId);
        this.editedItem = {
            properties: {
                id: this.itemsDetail[indexInItemsList]['properties']['ranch_id'],
                harvest_type: cropTypeSelected !== null ? cropTypeSelected['value'] : null,
                name: ranchName,
                policy: this.itemsDetail[indexInItemsList]['properties']['policy']
            }
        }
        this.patchRanch();
    }

    modifySowingRanchFromMap(
        ranchName: string, 
        cropTypeSelected: object | null, 
        coords: google.maps.LatLngLiteral[][][][],
        type: string,
        oldFeature: google.maps.Data.Feature
    ){
        if(this.isSowing){
            this.updateSowingRanch(ranchName, cropTypeSelected, oldFeature);
        }else{
            this.updateHarvestRanch(ranchName, cropTypeSelected, oldFeature);
        }
    }

    getCropTypeValue(cropTypeSelected: object | null){
        if(cropTypeSelected !== null){
            return this.isSowing ? cropTypeSelected['id'] : cropTypeSelected['value']
        }
        return null
    }

    modifyRanchFromMap(feature: google.maps.Data.Feature){
        let customIdFeature = feature.getProperty('customId') as string;
        this.editPolygon(customIdFeature)
    }
    save() {
        if (this.editedIndex > -1) {
            if (this.isSowing) {
                 this.editedItem['harvest_type'] =  this.comboCropTypeValue == null ? null : this.comboCropTypeValue['value'];
                this.patchSowingRanch(this.editedItem);
            } else {
                delete this.headersRanchsHarvest[0]['width'];
                if(this.policyValue !== null){
                    this.editedItem['properties']['policy'] = this.policyValue;
                }
                 this.editedItem['properties']['harvest_type'] = this.getCropTypeValue(this.comboCropTypeValue);
                this.patchRanch();
            }
        }
        this.updateComboCropTypeValue(null);
    }

    cancelEditPolygonAction() {
        if (!this.isSowing) {
            if(this.mapDetailHarvestSowing){
                this.mapDetailHarvestSowing.discardCurrentPolygon();
            }
        }
    }

    deleteRanch(item) {
        let self = this;
        this.ranchToDelete = null;
        this.ranchToDelete = this.isSowing ? item['id'] : item['properties']['ranch_id'];
        this.showDeleteConfirmationDialog();
    }

    patchRanch() {
        let self = this;
        // console.clear();
        let { coords, type } = this.getCoordsFromEditablePolygon();
        let harvestTypeValue = isNullOrEmpty(this.editedItem['properties']['harvest_type']) ? null : this.getCropTypeIdByName(this.editedItem['properties']['harvest_type']);
        // console.log("harvestTypeValue", harvestTypeValue);
        let hasCoords = coords.length > 0 ? true : false;
        let policyId = this.editedItem['properties']['policy']['id'];
        let data = {
            name: this.editedItem['properties']['name'],
            harvest_type: harvestTypeValue,
            policy: policyId,
            closing_condition: this.editedItem['properties']['closing_condition'],
            ...(hasCoords ? { [type]: coords } : {})
        };
        this.patchHarvestRanch(Number(this.editedItem['properties']['id']), data);
    }

    getCropTypeIdByName(harvestTypeName: string){
        let cropType = this.cropTypeOptions.findIndex(item => item['value'] === harvestTypeName);
        if(cropType !== -1){
            return this.cropTypeOptions[cropType]['id'];
        }
        return null
    }

    patchHarvestRanch(ranchId, data){
        InsuranceServices.patchRanch(ranchId, data)
        .then(res => {
            this.editSowingRanch();
            this.$_successDeleteRecipients('Chacra editada correctamente');
            this.reloadFarmingDetail();
        })
        .catch(error => {
            this.showErrorPathRanch(error);
        });
    }

    getCoordsFromEditablePolygon(): {
        coords: google.maps.LatLngLiteral[][][],
        type: string
    }{
        return this.mapDetailHarvestSowing.getCoordsFromCurrentEditablePolygon()
    }

    patchSowingRanch(itemToPatch) {
        let self = this;
        let harvestTypeId = this.editedItem['harvest_type'] == null ? null : this.getCropTypeIdByName(this.editedItem['harvest_type']);
        if (itemToPatch) {
            let {coords, type} = this.getCoordsFromEditablePolygon();
            let hasCoords = coords.length > 0 ? true : false;
            let data = {
                "name": this.editedItem['name'],
                "harvest_type": harvestTypeId,
                ...(hasCoords ? { 
                    [type]: coords,
                } : {})
            }
            InsuranceServices.patchSowingRanch(data, Number(itemToPatch['id']))
                .then(res => {
                    self.editSowingRanch();
                    self.$_successDeleteRecipients('Chacra editada correctamente');
                    //    self.getPolygons();
                    self.reloadFarmingDetail();
                })
                .catch(error => {
                    self.showErrorPathRanch(error);
                });
        }
    }

    showErrorPathRanch(error) {
        let msg = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
        } else {
            msg = 'No se pudo editar la chacra';
        }
        this.$_showHistoricalError(msg);
    }

    editSowingRanch() {
        if(this.editedIndex > -1){
            Object.assign(this.itemsDetail[this.editedIndex], this.editedItem);
            this.comboCropTypeValue = null;
            this.ranchName = '';
            // this.policyRanch = '';
            this.close();
        }
    }

    showDeleteConfirmationDialog() {
        this.deleteModalTitle = 'Eliminar Chacras';
        this.deleteBody = '¿Está seguro que desea eliminar las chacras seleccionadas?';
        this.confirmationDelete = true;
    }

    deleteHarvestRanch() {
        let self = this;
        let ranchsIds = this.selectedRanchs.map(s => s['properties']['ranch_id']);
        InsuranceServices.deleteRanch(ranchsIds)
            .then(response => {
                self.setLoadingMap(true);
                let msg = '';
                if (response && response.message) {
                    msg = response.message;
                } else {
                    msg = 'Chacras de Cosecha Eliminadas con éxito';
                }
                for (let index = 0; index < self.selectedRanchs.length; index++) {
                    const feature = self.selectedRanchs[index];
                    this.unselectFeatureInMap(feature);
                }

                self.itemsDetail = removeItemsFromList(self.itemsDetail, self.selectedRanchs, 'id');

                self.selectedRanchs = [];
                self.$_successDeleteRecipients(msg);
                self.getPolygons();
            })
            .catch(err => {
                self.showCatchLoadingDialog(err, 'Ocurrio un error');
            });
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            // this.showLoadingDialog('Eliminando ' + this.topic);

            if (this.isSowing) {
                this.deleteSowingRanchs();
            } else {
                this.deleteHarvestRanch();
            }
        } else {
            this.confirmationDelete = false;
        }
    }

    customItemClass() {
        return 'truncate-row'
    }

    deleteSowingRanchs() {
        let self = this;
        let ranchsIds = getIdsFromList(this.selectedRanchs);
        this.showLoadingDialog('Eliminando Chacras de Siembra');
        InsuranceServices.deleteSowingRanchs(ranchsIds)
            .then(response => {
                this.$_successLoadingDialog({
                    response: response,
                    alternative_msg: 'Chacras de Siembra Eliminadas con éxito'
                })
                self.itemsDetail = removeItemsFromList(self.itemsDetail, self.selectedRanchs, 'id');
                self.selectedRanchs = [];
                self.getPolygons();
            })
            .catch(err => {
                self.selectedRanchs = [];
                self.showCatchLoadingDialog(err, 'Ocurrio un error');
            });
    }

    discardRanchs() {
        this.showDeleteConfirmationDialog();
    }

    getFileName() {
        let type = this.isSowing ? 'siembra' : 'cosecha';
        let company = this.patchData['company']['name'];
        let actualDate = moment().format('DD-MM-YYYY_HH-mm-ss');
        let format = '.geojson';
        let fileName = company + '_chacras-' + type + '_' + actualDate + '_' + format;
        return fileName;
    }

    get isCarrierLimited(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER_LIMITED];
    }


    downloadGeoJson() {
    const fileName = this.getFileName();
    let dataToDownload;

    if (this.selectedRanchs.length > 0) {
        // Descargar chacras seleccionadas
        dataToDownload = {
            type: 'FeatureCollection',
            features: this.ranchsToDownload
        };
    } else {
        // Descargar todas las chacras
        dataToDownload = this.isSowing
            ? this.poligonsResponse['polygons']
            : this.poligonsResponse;
    }

    const jsonData = JSON.stringify(dataToDownload, null, 4);
    downloadFile(fileName, jsonData);
}

    addRanchsToList(newRanchs) {
        let oldItems = this.itemsDetail;
        this.itemsDetail = [];
        oldItems.push(newRanchs);
        setTimeout(() => {
            this.itemsDetail = oldItems;
        }, 500);
    }

    get getSowingId() {
        return this.existSowingDetail ? this.patchData['sowing']['id'] : null;
    }

    get getHarvestId() {
        return this.existHarvestDetail ? this.patchData['harvest']['id'] : null;
    }

    getCropTypeRanchSelected(item, combobox) {
        //check if harvest_type is a string
        if (typeof item['harvest_type'] === 'string') {
            let indexCropType = this.cropTypeOptions.findIndex(
                croptype => croptype['value'] === item['harvest_type']
            );
            if (indexCropType !== -1) {
                if (combobox) {
                    return this.cropTypeOptions[indexCropType];
                }
                return this.cropTypeOptions[indexCropType]['value'];
            }
        }
        return null;
        
    }

    formatList(value){
        return getOverlapAlertText(formatCommaSeparatedStringList(value))
    }

    getCropTypeHarvestRanchSelected(item, combo) {
        if (item && item['properties']['harvest_type']) {
            // console.log("this.cropTypeOptions", this.cropTypeOptions);
            // console.log("harvest_type", item['properties']['harvest_type']);
            let indexCropType = this.cropTypeOptions.findIndex(
                croptype => croptype['value'] === item['properties']['harvest_type']
            );
            if (indexCropType !== -1) {
                if (combo) {
                    return this.cropTypeOptions[indexCropType];
                } else {
                    return this.cropTypeOptions[indexCropType]['value'];
                }
            }
        } else {
            return null;
        }
    }

    updateComboCropTypeValue(value) {
        this.comboCropTypeValue = value;
    }
    updateComboCropTypeResetValue(value) {
        this.comboCropTypeResetValue = value;
    }

    updatePolicyValue(value) {
        this.policyValue = value;
    }

    updatePolicyValueRv(value) {
        this.policyResetValue = value;
    }

    classifyRanchs() {
        let self = this;
        let sowingId = this.getSowingId;
        if (sowingId !== null) {
            this.showLoadingDialog('Clasificando Chacras de Siembra');
            InsuranceServices.sowingSplitRanchs(sowingId)
                .then(response => {
                    this.$_successLoadingDialog({
                        response: response,
                        alternative_msg: 'Chacras de siembra clasificadas con éxito'
                    })
                    self.addRanchsToList(response['new_ranches']);
                    self.reloadFarmingDetail();
                })
                .catch(error => {
                    if (error && error.response && error.response.status !== 200) {
                        self.showCatchLoadingDialog(error, 'Ocurrio un error');
                    }
                });
        }
    }

    reloadFarmingDetail() {
        this.$emit('update-farming-detail');
    }

    visibilityModalJoinRanchs(value) {
        this.visibleModalJoinRanchs = value;
    }

    visibilityModalGetNamesFromGeojson(value) {
        this.visibleModalGetNamesFromGeoJson = value;
    }

    visibilityModalNewHarvest(value) {
        this.policyToSelect = null;
        this.visibleModalNewHarvest = value;
    }

    parseNumber(value, key) {
        if(value == null){
            return '-'
        }
        return getValueParsedByType(value, unitsValuesChoices[key]);
    }
    parseBoolean(value) {
        return booleanFormatter(value)
    }

    getPolygons() {
        let self = this;
        this.showFarmingMap = true;
        this.setLoadingMap(true);
        this.pendingRanchs(true);
        try{
            if(this.mapDetailHarvestSowing && typeof this.mapDetailHarvestSowing.removeGeoJsonFeatures === 'function'){
                this.mapDetailHarvestSowing.removeGeoJsonFeatures();
            }
        }catch(e){
        }
        if (this.isSowing) {
            let sowingId = this.getSowingId;
            if (sowingId !== null) {
                
                InsuranceServices.getSowingPolygons({
                    id: this.getSowingId
                })
                    .then(response => {
                            self.setPolygonsOnMap(response);
                            self.setLoadingMap(false);
                            self.pendingRanchs(false);
                        
                    })
                    .catch(err => {
                        self.setLoadingMap(false);
                        self.pendingRanchs(false);
                        // self.$emit('show-error-loading-dialog', err);
                    })
            } else {
                this.setLoadingMap(false);
                this.pendingRanchs(false);
            }
        } else {
            let harvestId = this.getHarvestId;
            if (harvestId !== null) {
                InsuranceServices.getHarvestRanchPolygons(this.getHarvestId)
                    .then(response => {
                        self.setRanchsHarvest(response['ranchs']);
                        self.setPolygonsOnMap(response['ranchs']);
                        self.pendingRanchs(false);
                        self.setLoadingMap(false);
                    })
                    .catch(err => {
                        self.pendingRanchs(false);
                        self.setLoadingMap(false);
                        // self.$emit('show-error-loading-dialog', err);
                    })
            } else {
                this.setLoadingMap(false);
                this.pendingRanchs(false);
            }
        }
    }

    saveHarvestedPolygon(res) {
        if (res.features.length > 0) {
            let self = this;
            let geojsonFeatures = res.features;
            for (let index = 0; index < geojsonFeatures.length; index++) {
                const currentFeature = geojsonFeatures[index];
                let customId = getUniqueId();
                currentFeature['properties']['customId'] = customId;
            }
        }
        this.harvestedPolygons = res;
        this.toggleProgressPolygon();
    }

    getEnabledVehicles() {
        let self = this;
        // if(this.isSowing){
        this.loadingAvailableVehicles = true;
        this.updateAvailableVehicles([]);
        InsuranceServices.getEnabledVehicles()
            .then(response => {
                this.loadingAvailableVehicles = false;
                this.setAvailableVehicles(response);
                this.updateSelectedCompany(this.patchData['company']);
            })
            .catch(err => {
                this.loadingAvailableVehicles = false;
                this.updateAvailableVehicles([]);
            });
        // }
    }

    setAvailableVehicles(res){
        if(this.isSowing){
            this.availableVehicles = res['sowing_vehicles']
        }else{
            this.availableVehicles = res['harvest_vehicles']
        }
    }

    @Watch('itemsDetail', { immediate: true, deep: true })
    observableItems(items) {
        this.updateRowTooltips();
    }

    setPolygonsOnMap(res) {
        this.poligonsResponse = res;
        let features = this.isSowing ? res['polygons']['features'] : res['features'];
        let self = this;
        features.forEach(feature => {
            // console.log("set polygons", item);
            // console.log("items detail", self.itemsDetail);
            let featureName = feature['properties']['name'];
            feature['properties']['customId'] = self.getFeatureCustomIdFromTable(featureName);
        });
        if (this.isSowing) {
            res['polygons']['features'] = features;
            this.showGeojsonInMap(res['polygons']);
        } else {
            res['features'] = features;
            this.showGeojsonInMap(res);
        }
    }

    getFeatureCustomIdFromTable(featureName) {
        if(this.isSowing){
            let rowIndex = this.itemsDetail.findIndex(item => item['name'] === featureName);
            if(rowIndex !== -1){
                return this.itemsDetail[rowIndex]['customId'];
            }
        }else{
            let rowIndex = this.itemsDetail.findIndex(item => item['properties']['name'] === featureName);
            if(rowIndex !== -1){
                return this.itemsDetail[rowIndex]['properties']['customId'];
            }
        }
    }

    showGeojsonInMap(res) {
        this.mapDetailHarvestSowing.addGeoJson(res, 'customId');
    }

    selectAllRanchs(itemsList) {
        // console.log("idk", itemsList);
        this.selectedRanchs = [];
        if (!itemsList['value']) {
            itemsList['items'].forEach(item => {
                this.unselectFeatureInMap(item);
            });
        } else {
            itemsList['items'].forEach(element => {
                this.tableRanchClicked({
                    item: element,
                    value: itemsList['value']
                });
            });
        }
    }

    unselectFeatureInMap(feature){
        this.mapDetailHarvestSowing.unselectFeature(feature);
    }

    tableRanchClicked(itemSelected) {
        this.updateSelectedRanchList(itemSelected);
    }

    updateRowItemCustomId(rowItem, customId){
        if(this.isSowing){
            this.$set(rowItem, 'properties', {
                customId: customId
            });
        }
    }

    updateSelectedRanchList(rowItem){
        let self = this;
        let action = rowItem['value']; //select or unselect
        let rowCustomId = this.isSowing ? rowItem['item']['customId'] : rowItem['item']['properties']['customId']
        let customIdExistInSelectedRanchs = this.featureExistInSelectedRanchsList(rowCustomId)
        let indexInGlobalRanchList = this.featureExistInItemsList(rowCustomId)
        // console.log("updateSelectedRanchList", rowItem);
        if(customIdExistInSelectedRanchs == -1 && action){
            // console.log("agrego la chacra a las seleccionadas");
            this.updateRowItemCustomId(rowItem['item'], rowCustomId);
            self.selectedRanchs.push(rowItem['item'])
            this.updateSelectedFieldInRanchSelected(indexInGlobalRanchList, 'true');
        }else{
            // console.log("quito la fila de las seleccionadas");
            //la deselecciono del mapa
            this.mapDetailHarvestSowing.unselectFeatureFromTable(rowCustomId);

            //la elimino de las chacras seleccionadas
            // console.log("elimino de las chacras seleccionadas el indice", customIdExistInSelectedRanchs);
            // console.log("num chacras seleccionadas antes", this.selectedRanchs);
            self.selectedRanchs.splice(customIdExistInSelectedRanchs, 1);
            this.updateSelectedFieldInRanchSelected(indexInGlobalRanchList, 'false');
            // console.log("num chacras seleccionadas despues", this.selectedRanchs);
        }
        this.selectFeaturesInMap(); //actualizo las chacras seleccionadas en el mapa
        this.sortItemsBySelectedKey(); //ordeno las chacras en base a la key selected
    }

    selectFeaturesInMap() {
        // console.log("select features in map", this.selectedRanchs);
        this.mapDetailHarvestSowing.selectFeature(this.selectedRanchs);
    }

    createNewRanchManually() {
        this.mapDetailHarvestSowing.addNewPolygon();
    }

    viewRawPolygons(raw) {
        this.setLoadingMap(true);
        if (raw) {
            this.loadingBtnRawPolygons = true;
        } else {
            this.loadingBtnUnRawPolygons = true;
        }

        let self = this;
        InsuranceServices.getSowingPolygons({
            id: this.getSowingId,
            raw: raw
        })
            .then(response => {
                // console.log("polygons sowing", response);
                if (raw) {
                    self.typePolygonViewing = 'raw';
                    self.loadingBtnRawPolygons = false;
                } else {
                    self.typePolygonViewing = 'unraw';
                    self.loadingBtnUnRawPolygons = false;
                }
                self.setPolygonsOnMap(response);

                self.setLoadingMap(false);
            })
            .catch(err => {
                if (raw) {
                    self.loadingBtnRawPolygons = false;
                } else {
                    self.loadingBtnUnRawPolygons = false;
                }
                self.setLoadingMap(false);
            });
    }

    debouncedOnChangeRanchName(item) {
        let self = this;
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            if(this.isSowing){
                this.editedItem['name'] = this.ranchName;
            }else{
                this.editedItem['properties']['name'] = this.ranchName;
            }
        }, 800);
    }

    get mapDetailHarvestSowing(): HTMLFormElement {
        return this.$refs.mapDetailHarvestSowing as HTMLFormElement;
    }

    dateFormatter(value) {
        return formatDate(value, true)
    }

    addAvailableVehicle() {
        this.selectedVehicles = addItemsToListIfAreNotAdded(
            this.selectedVehicles,
            this.availableVehiclesSelected,
            'id'
        );
        this.availableVehiclesSelected = [];
    }

    removeSelectedVehicle(itemsToExclude) {
        this.selectedVehicles = removeItemsFromList(this.selectedVehicles, itemsToExclude, 'id');
        this.availableSelectedVehicles = [];
    }

    excludeSelectedVehicle(vehicle) {
        this.removeSelectedVehicle([vehicle]);
    }

    recalculateClick() {
        // console.log("recalculate");
        if (this.isSowing) {
            this.recalculatingSowing = true;
            this.recalculateSowing();
        } else {
            this.recalculatingHarvest = true;
            this.recalculateHarvest();
        }
    }

    recalculateSowing() {
        let self = this;
        if (this.getSowingId !== null) {
            this.showLoadingDialog('Recalculando Siembra...');
            InsuranceServices.sowingRecalculate(this.getSowingId)
                .then(response => {
                    this.recalculatingSowing = false;
                    let msg = '';
                    if (response && response.message) {
                        msg = response.message;
                    } else {
                        msg = 'Siembra recalculada con éxito';
                    }
                    self.successLoadingDialog(response, msg);
                })
                .catch(error => {
                    this.recalculatingSowing = false;
                    self.showCatchLoadingDialog(error, 'Ocurrio un error');
                });
        }
    }

    recalculateHarvest() {
        let self = this;
        if (this.getHarvestId !== null) {
            this.showLoadingDialog('Recalculando Cosecha...');

            InsuranceServices.harvestRecalculate(this.getHarvestId)
                .then(response => {
                    this.recalculatingHarvest = false;
                    let msg = '';
                    if (response && response.message) {
                        msg = response.message;
                    } else {
                        msg = 'Cosecha recalculada con éxito';
                    }
                    self.successLoadingDialog(response, msg);
                })
                .catch(error => {
                    this.recalculatingHarvest = false;
                    self.showCatchLoadingDialog(error, 'Ocurrio un error');
                });
        }
    }

    get formIsValid() {
        if (this.dateRangeSelected.length == 0) {
            return false;
        }
        if (this.description === '' || this.description == null) {
            return false;
        }
        // if(!this.existsSelectedVehicles){
        //     return false
        // }

        return true;
    }

    triggerSubmit() {
        if (this.isSowing) {
            if (this.existSowingDetail) {
                this.showLoadingDialog('Modificando Siembra...');
                this.patchSowing();
            } else {
                this.showLoadingDialog('Creando Siembra...');
                this.postSowing();
            }
        } else {
            if (this.existHarvestDetail) {
                this.showLoadingDialog('Modificando Cosecha...');
                this.patchHarvest();
            } else {
                this.showLoadingDialog('Creando Cosecha...');
                this.postHarvest();
            }
        }
    }

    get getData() {
        let formData = {
            start_date: this.dateRangeSelected[0],
            end_date: this.dateRangeSelected[1],
            active: this.isActive,
            name: this.description,
            vehicles: getIdsFromList(this.selectedVehicles)
        };

        if (this.editing) {
            this.$set(formData, 'farming', this.patchData['id']);
        }

        return formData;
    }

    patchSowing() {
        let self = this;
        InsuranceServices.patchSowing(this.getData, this.getSowingId)
            .then(response => {
                // console.log("success patch sowing");
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'Siembra modificada con éxito';
                }
                self.successLoadingDialog(response.data,msg);
            })
            .catch(err => {
                self.showCatchLoadingDialog(err, 'Ocurrio un error');
                // console.log("catch post sowing");
            });
    }

    postSowing() {
        let self = this;
        InsuranceServices.postSowing(this.getData)
            .then(response => {
                // console.log("success post sowing");
                let msg = '';
                if (response && response.message) {
                    msg = response.message;
                } else {
                    msg = 'Siembra creada con éxito';
                }
                self.successLoadingDialog(response, msg);
            })
            .catch(err => {
                self.showCatchLoadingDialog(err, 'Ocurrio un error');
                // console.log("catch post sowing");
            });
    }

    patchHarvest() {
        let self = this;
        InsuranceServices.patchHarvest(this.getData, this.getHarvestId)
            .then(response => {
                // console.log("success patch harvest");
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'Cosecha modificada con éxito';
                }
                self.successLoadingDialog(response.data, msg);
            })
            .catch(err => {
                self.showCatchLoadingDialog(err, 'No se pudo modificar la cosecha');
            });
    }

    postHarvest() {
        let self = this;
        InsuranceServices.postHarvest(this.getData)
            .then(response => {
                // console.log("success post harvest");
                let msg = '';
                if (response && response.message) {
                    msg = response.message;
                } else {
                    msg = 'Cosecha creada con éxito';
                }
                self.successLoadingDialog(response, msg);
            })
            .catch(err => {
                self.showCatchLoadingDialog(err, 'No se pudo crear la cosecha');
            });
    }

    successLoadingDialog(response, alternative_msg) {
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.reloadFarmingDetail();
    }

    showCatchLoadingDialog(error, alternative_msg) {
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    updateDescriptionValue(value) {
        this.description = value;
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }

    intersectRanch(featureId: number, coords: Array<google.maps.LatLng>, polyName: string) {
        let self = this;
        let data = {
            name: polyName,
            polygon: coords
        };

        this.showLoadingDialog('Dividiendo chacras...');

        InsuranceServices.sowingIntersectRanchs(data, featureId)
            .then(response => {
                let msg = '';
                if (response && response.message) {
                    msg = response.message;
                } else {
                    msg = 'Chacras de siembra dividas con éxito';
                }

                self.$emit('show-success-loading-dialog', response, msg);
                self.reloadFarmingDetail();
            })
            .catch(error => {
                if (error && error.response && error.response.status !== 200) {
                    self.showCatchLoadingDialog(error, 'Ocurrio un error');
                    self.mapDetailHarvestSowing.cancelPolygon();
                }
            });
    }

    filterByCompany(companyName) {
        return this.companySelected == null ? true : companyName === this.companySelected['name'];
    }

    updateRanchsToDownload(ranchs) {
        this.ranchsToDownload = [];
        this.ranchsToDownload = ranchs;

        // console.log("ranchs to download", this.ranchsToDownload);
    }

    get canSaveRanch() {
        if (this.isSowing) {
            return this.editedItem['name'] !== '';
        } else {
            return this.ranchName !== '' && this.policyValue !== null;
        }
    }

    addNewPolicyToList(newPolicy: object) {
        this.policyToSelect = null;
        this.policiesList = addItemsToListIfAreNotAdded(this.policiesList, [newPolicy], 'id');
        this.policyToSelect = newPolicy;
    }

    updatePolicyInList(updatedPolicy) {
        this.policyToSelect = null;
        let indexToUpdate = matchedIndexIdInArray(this.policiesList, updatedPolicy['id']);

        if (indexToUpdate !== -1) {
            this.$set(this.policiesList[indexToUpdate], 'number', updatedPolicy['number']);
            this.$set(this.policiesList[indexToUpdate], 'secured_area', updatedPolicy['secured_area']);
        }
    }

    getVehicleData(keyToMatch, vehicleId) {
        // console.log("vehicles to match", this.patchData[this.type]['vehicles']);
        let vehicleList = this.patchData[this.type]['vehicles'];
        let indexVehicle = vehicleList.findIndex(item => item['id'] == vehicleId);
        if (indexVehicle !== -1) {
            if (vehicleList[indexVehicle]) {
                return vehicleList[indexVehicle][keyToMatch];
            } else {
                return '-';
            }
        } else {
            return '-';
        }
    }

    forceCalculateNow() {
        this.forcingCalculate = true;
        let self = this;
        if (!this.isSowing) {
            InsuranceServices.harvestForceRecalculate(this.getHarvestId)
                .then(response => {
                    let msg = '';
                    if (response && response.message) {
                        msg = response.message;
                    } else {
                        msg = 'La cosecha se está recalculando';
                    }
                    self.recalculating = true;
                    self.forcingCalculate = false;
                    self.successLoadingDialog(response, msg);
                })
                .catch(err => {
                    self.forcingCalculate = false;
                    self.showCatchLoadingDialog(err, 'Ocurrio un error');
                });
        } else {
            InsuranceServices.sowingForceRecalculate(this.getSowingId)
                .then(response => {
                    let msg = '';
                    if (response && response.message) {
                        msg = response.message;
                    } else {
                        msg = 'La siembra se está recalculando';
                    }
                    self.recalculating = true;
                    self.forcingCalculate = false;
                    self.successLoadingDialog(response, msg);
                })
                .catch(err => {
                    self.forcingCalculate = false;
                    self.showCatchLoadingDialog(err, 'Ocurrio un error');
                });
        }
    }

    featureExistInSelectedRanchsList(featureCustomId: string): number{
        if(this.isSowing){
            return this.selectedRanchs.findIndex(item => item['customId'] === featureCustomId)
        }
        return this.selectedRanchs.findIndex(
            item => item['properties']['customId'] === featureCustomId
        )
    }

    featureExistInItemsList(featureCustomId: string): number{
        if(this.isSowing){
            return this.itemsDetail.findIndex(item => item['customId'] === featureCustomId)
        }
        return this.itemsDetail.findIndex(
            item => item['properties']['customId'] === featureCustomId
        )
    }

    ranchToUnselectFromMap(featureCustomId: string) {
        // //des-seleccionar chacras desde el mapa con Control
        let indexInGlobalRanchList = this.featureExistInItemsList(featureCustomId)

        if (indexInGlobalRanchList !== -1) {
            //si la chacra existe en la lista de seleccionadas
            //la des-selecciono
            this.updateSelectedRanchList({
                item: this.itemsDetail[indexInGlobalRanchList],
                value: false
            })        
        }
    }



    selectRanchInListFromMap(geojsonSelected) {
        //selecciono la chacra en el mapa con Control
        let indexInSelectedRanchs = this.featureExistInSelectedRanchsList(geojsonSelected['properties']['customId']);
        let indexInGlobalRanchList = this.featureExistInItemsList(geojsonSelected['properties']['customId'])

        if (indexInSelectedRanchs == -1) {
          //si la chacra no existe en la lista de seleccionadas
            if (indexInGlobalRanchList !== -1) {
                //y existe en la lista Global de chacras
                //la puedo seleccionar 
                // console.log("selecciono la chacra desde el mapa");
                this.updateSelectedRanchList({
                    item: this.itemsDetail[indexInGlobalRanchList],
                    value: true
                });
            }
        }
        
    }

    updateSelectedFieldInRanchSelected(indexInGlobalRanchList: number, action: string){
        this.$set(this.itemsDetail[indexInGlobalRanchList], 'selected', action); //'true' o 'false'
    }

    seeInNewTabFromMap(feature: google.maps.Data.Feature){
        let ranchId = feature.getProperty('ranch_id');
        if(this.isSowing){
            this.seeRanchDetail({
                id: ranchId
            })
        }else{
            this.seeRanchDetail({
                properties: {
                    ranch_id: ranchId
                }
            })
        }
    }

    seeRanchDetail(item) {
        // console.log("ver detalle chacra", item);
        let ranchId = this.isSowing ? item['id'] : item['properties']['ranch_id'];
        
        let url = getUrlRanchDetail(ranchId);//harvest url

        if(this.isSowing){
            url = getUrlRanchSowingDetail(ranchId);
        }
        goToUrl(url, true);
    }

    seeHarvestProgress() {
        let baseUrl = NAME_ROUTES.INSURANCE_FARMING_ANALYTIC.path;
        let companyId =
            this.patchData && this.patchData['company'] && this.patchData['company']['id']
                ? this.patchData['company']['id']
                : null;
        let insuranceCompanyId =
            this.patchData &&
            this.patchData['insurance_farming'] &&
            this.patchData['insurance_farming']['insurance_company']
                ? this.patchData['insurance_farming']['insurance_company']
                : null;
        let farmingId = this.patchData && this.patchData['id'] ? this.patchData['id'] : null;

        if (companyId) {
            baseUrl += '/?c_id=' + companyId;
        }

        if (insuranceCompanyId) {
            baseUrl += '&ic_id=' + insuranceCompanyId;
        }
        if (farmingId) {
            baseUrl += '&f_id=' + farmingId;
        }

        goToUrl(baseUrl, true);
    }

    sortItemsBySelectedKey() {
        this.itemsDetail.sort(function(a, b) {
            return b['selected'].localeCompare(a['selected']);
        });
    }

    viewVehicleDetail(item) {
        // console.log("viewVehicleDetail", item);
        let vehicleType = this.isSowing ? farmingTypeOptions.sowing : farmingTypeOptions.harvest;
        let url = getUrlVehicleConfiguration(item['id'], this.patchData['id'], vehicleType);
        goToUrl(url, true);
    }
}
